import { SubmissionError } from 'redux-form'
import { getShoppingData } from 'actions/shoppingData'
import { rest } from 'services'
import { APPLY_COUPON_FORM_FIELD_NAME } from './constants'

export const submitApplyCouponForm = values => async dispatch => {
  try {
    await dispatch(getShoppingData(rest.api.applyCoupon, { ...values }))
  } catch ({ status: { description }}) {
    throw new SubmissionError({
      [APPLY_COUPON_FORM_FIELD_NAME]: description
    })
  }
}
